import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-login" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "ss-login-logo",
  src: "/static/img/ss-logo.png",
  alt: "ERP - Sabre Sistemas"
}, null, -1)
const _hoisted_5 = { class: "ss-login-dados-autenticacao" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "Chave do Parceiro", -1)
const _hoisted_9 = { class: "ant-input-affix-wrapper ss-login-input" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-prefix" }, [
  /*#__PURE__*/_createElementVNode("span", {
    type: "user",
    role: "img",
    "aria-label": "user",
    class: "anticon anticon-user"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      focusable: "false",
      class: "",
      "data-icon": "wallet",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      viewBox: "64 64 896 896"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1080 0 40 40 0 10-80 0z" })
    ])
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "ss-login-consultor" }, [
  /*#__PURE__*/_createTextVNode("Ainda não é parceiro?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://sabresistemas.com.br/fale-com-consultor/"
  }, "Fale com um consultor.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_quadro_login = _resolveComponent("quadro-login")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.state.mensagemAlerta)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                message: _ctx.state.mensagemAlerta,
                banner: ""
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.chaveParceiro) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.identificarAmbiente && _ctx.identificarAmbiente(...args)), ["enter"])),
                  type: "text",
                  class: "ant-input hidden"
                }, null, 544), [
                  [_vModelText, _ctx.state.chaveParceiro]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.identificarAmbiente && _ctx.identificarAmbiente(...args))),
            class: "ss-login-btn"
          }, "Avançar"),
          _hoisted_11
        ])
      ]),
      _createVNode(_component_quadro_login)
    ])
  ]))
}